import { EpicSettings, EpicSettingsFromJSON } from "../EpicSettings";
import { Tag, TagFromJSON } from "../Tag";

export interface ProjectWithChildren {
  id: number;
  subject: string;
  tags: Array<Tag>;
  account: string | null;
  bitmaker_settings: EpicSettings;
  assignee: string | null;
  assignee_id: number | null;
  parent_id: number | null;
  children?: Array<ProjectWithChildren>;
}

export function ProjectWithChildrenFromJSON(json: any): ProjectWithChildren {
  const children = Array.isArray(json["children"])
    ? json["children"].map(ProjectWithChildrenFromJSON)
    : [];

  return {
    id: json["id"],
    subject: json["subject"],
    tags: Array.isArray(json["tags"]) ? json["tags"].map(TagFromJSON) : [],
    account: json["account"] ?? null,
    bitmaker_settings: json["bitmaker_settings"]
      ? EpicSettingsFromJSON(json["bitmaker_settings"])
      : ({} as EpicSettings),
    assignee: json["assignee"] ?? null,
    assignee_id: json["assignee_id"] ?? null,
    parent_id: json["parent_id"] ?? null,
    ...(children.length > 0 ? { children } : {}),
  };
}
